import { Link } from "react-router-dom";
import { APP_HOME_URL } from "../config";
import "../styles/pricing.css";

export default function PurchaseAgreement() {
  return (
    <article className="pricing-page">
      <header className="pricing-hero">
        <p className="pricing-kicker">REChecklist · DreamHome Journey</p>
        <h1>Purchase Agreement</h1>
        <p className="lead pricing-lead">
          Clear terms for paid desk subscriptions. Please read before you complete checkout.
        </p>
      </header>

      <section className="pricing-cart">
        <h2>Billing &amp; renewal</h2>
        <ul>
          <li>Paid plans renew on a monthly cycle unless cancelled.</li>
          <li>Cancel anytime. You must cancel at least 72 hours before the next renewal to avoid the next charge.</li>
          <li>No refunds on completed billing periods.</li>
          <li>Plan name, price, and cycle are shown on the Pay page before you confirm with PayPal.</li>
        </ul>
      </section>

      <section className="pricing-trust">
        <h2>Data handling</h2>
        <div className="pricing-trust__grid">
          <p>
            <strong>Your data belongs to you.</strong> We do not sell or share client journey data
            for advertising lists.
          </p>
          <p>
            <strong>Local-first client work.</strong> In this build, checklist and portfolio data
            are stored on your device. You are responsible for exporting what you need.
          </p>
          <p>
            <strong>After account closure.</strong> We do not retain your client checklist data on
            our servers after closure. Remove local copies on devices you control.
          </p>
        </div>
      </section>

      <section className="pricing-closure">
        <h2>Liability &amp; as-is use</h2>
        <ol>
          <li>
            Use of the portal is provided as-is. REChecklist is a workflow companion — not a
            California DRE certification, legal opinion, or substitute for brokerage compliance.
          </li>
          <li>
            You remain responsible for accurate client records, exports, and compliance with your
            office policies.
          </li>
          <li>
            Account closure: export first, then cancel (72-hour buffer before renewal), then confirm
            in the closure dialog.
          </li>
        </ol>
        <p className="pricing-agreement-link">
          <Link to="/pricing">Back to Pricing</Link>
          {" · "}
          <a href={`${APP_HOME_URL}/privacy`}>Privacy</a>
          {" · "}
          <a href={`${APP_HOME_URL}/terms`}>Terms</a>
          {" · "}
          <Link to="/pay">Continue to Pay</Link>
        </p>
      </section>
    </article>
  );
}
